export default "__VITE_ASSET__ee239935__"